import type { KnowledgeView } from "./knowledge-parts";

export function KnowledgeNotice({ knowledge }: { knowledge: KnowledgeView }) {
  if (knowledge.status === "unavailable") {
    return <p role="status" className="mt-2 text-xs text-app-fg-muted">Não foi possível consultar os materiais da clínica nesta resposta. Não considere as orientações desses materiais confirmadas.</p>;
  }
  if (knowledge.status === "empty") {
    return <p className="mt-2 text-xs text-app-fg-muted">Nenhum trecho dos materiais da clínica foi encontrado nesta consulta.</p>;
  }
  if (!knowledge.sources.length) return null;
  return (
    <aside aria-label="Fontes consultadas nesta resposta" className="mt-2 text-xs text-app-fg-muted">
      <p>Fontes consultadas nesta resposta</p>
      <ul className="mt-1 space-y-1">
        {knowledge.sources.map(source => (
          <li key={`${source.documentId}:${source.revision}`} className="break-all">
            Documento <code>{source.documentId}</code> · revisão {source.revision}
          </li>
        ))}
      </ul>
    </aside>
  );
}
